export default __webpack_public_path__ + "static/media/polaroid8.64ebdbff.jpg";